import React, { useContext } from "react";
import { HeaderContext } from "contexts/";

export default function ContenfulQuickLink(props) {
	const { position = "fixed" } = props;
	const headerCtx = useContext(HeaderContext);
	let entryId = props.entryId || headerCtx.pageId;

	const space = props.IR ? process.env.CMS_CONTENTFUL_SPACE_ID : process.env.WEB_PROP_CONTENTFUL_SPACE_ID;
	return (
		<>
			{entryId && (
				<a href={`https://app.contentful.com/spaces/${space}/entries/${entryId}`} target="_blank">
					<div title={props.title} className="contentfulLogo">
						<svg
							width={`${props.width || 50}px`}
							viewBox="0 0 256 289"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							preserveAspectRatio="xMidYMid"
						>
							<g>
								<path
									d="M87.333315,200.77659 C72.0274763,186.371095 63.0240418,166.563539 63.0240418,144.054953 C63.0240418,121.546366 72.0274763,101.73881 86.4329716,87.333315 C99.0377799,74.7285067 99.0377799,54.9209507 86.4329716,42.3161423 C73.8281632,29.711334 54.0206072,29.711334 41.4157989,42.3161423 C16.2061822,68.4261025 0,104.439841 0,144.054953 C0,183.670065 16.2061822,219.683803 42.3161423,245.793763 C54.9209507,258.398571 74.7285067,258.398571 87.333315,245.793763 C99.0377799,233.188955 99.0377799,213.381399 87.333315,200.77659 Z"
									fill="#FAE501"
								></path>
								<path
									d="M87.333315,87.333315 C101.73881,72.0274763 121.546366,63.0240418 144.054953,63.0240418 C166.563539,63.0240418 186.371095,72.0274763 200.77659,86.4329716 C213.381399,99.0377799 233.188955,99.0377799 245.793763,86.4329716 C258.398571,73.8281632 258.398571,54.0206072 245.793763,41.4157989 C219.683803,16.2061822 183.670065,0 144.054953,0 C104.439841,0 68.4261025,16.2061822 42.3161423,42.3161423 C29.711334,54.9209507 29.711334,74.7285067 42.3161423,87.333315 C54.9209507,99.0377799 74.7285067,99.0377799 87.333315,87.333315 Z"
									fill="#4FB5E1"
								></path>
								<path
									d="M200.77659,200.77659 C186.371095,216.082429 166.563539,225.085863 144.054953,225.085863 C121.546366,225.085863 101.73881,216.082429 87.333315,201.676934 C74.7285067,189.072125 54.9209507,189.072125 42.3161423,201.676934 C29.711334,214.281742 29.711334,234.089298 42.3161423,246.694106 C68.4261025,271.903723 104.439841,288.109905 144.054953,288.109905 C183.670065,288.109905 219.683803,271.903723 245.793763,245.793763 C258.398571,233.188955 258.398571,213.381399 245.793763,200.77659 C233.188955,189.072125 213.381399,189.072125 200.77659,200.77659 Z"
									fill="#F05751"
								></path>
								<ellipse
									fill="#0681B6"
									cx="64.8247287"
									cy="64.8247287"
									rx="31.5120209"
									ry="31.5120209"
								></ellipse>
								<ellipse
									fill="#CD4739"
									cx="64.8247287"
									cy="223.285177"
									rx="31.5120209"
									ry="31.5120209"
								></ellipse>
							</g>
						</svg>
					</div>
					<style jsx>{`
						.contentfulLogo {
							background: transparent;
							z-index: 100;
							position: ${position};
							left: 1em;
							bottom: 1em;
							cursor: pointer;
							padding: 5px;
							border-radius: 5px;
							opacity: 0.5;
						}

						.contentfulLogo:hover {
							box-shadow: 3px 3px 13px 0px black;
							opacity: 1;
						}
					`}</style>
				</a>
			)}
		</>
	);
}
